import { Component, OnInit, Input } from '@angular/core';
import { ProductInfo } from 'app/users/models/ProductInfo';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 're-product-information',
    templateUrl: './product-information.component.html',
    styleUrls: ['./product-information.component.scss'],
    standalone: false
})
export class ProductInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input()
  product: ProductInfo;

  @Input()
  showLinks = true;
}
